import { VerificationType } from "projects/shared/src/public-api";

export class VerificationModel {
    UserMailOrPhone: string;
    VerificationType?: VerificationType;
    VerificationCode?: string;
}
